// Texts for world 'robot': name on the map and the level titles, per language.
// The ids must be the level ids in levels.ts (npm run validate checks it); other languages must have the same ids as da (tsc).
import { defineWorldStrings } from '../../core/i18n';

export const strings = defineWorldStrings({
  da: {
    name: 'Hikke-robot',
    levels: {
      'gate': { title: 'Porten' },
      'switch': { title: 'Kontakten' },
      'belt': { title: 'Båndet' },
      'string-or-wire': { title: 'Snor eller ledning' },
      'battery': { title: 'Batteriet' },
      'all-the-way-round': { title: 'Hele vejen rundt' },
      'hiccup-robot': { title: 'Hikke-robotten' },
      'which-wire': { title: 'Hvilken ledning' },
      'battery-and-wire': { title: 'Batteri og ledning' },
      'copper-ball': { title: 'Kobberkuglen' },
      'robot-and-fan': { title: 'Robot og blæser' },
      'switch-and-wire': { title: 'Kontakt og ledning' },
      'lift': { title: 'Liften' },
      'nut-and-spring': { title: 'Møtrik og fjeder' },
      'master-workshop': { title: 'Mesterværkstedet' },
    },
    scene: { hic: 'HIK!' },
  },
  en: {
    name: 'Hiccup robot',
    levels: {
      'gate': { title: 'The gate' },
      'switch': { title: 'The switch' },
      'belt': { title: 'The belt' },
      'string-or-wire': { title: 'String or wire' },
      'battery': { title: 'The battery' },
      'all-the-way-round': { title: 'All the way round' },
      'hiccup-robot': { title: 'The hiccup robot' },
      'which-wire': { title: 'Which wire?' },
      'battery-and-wire': { title: 'Battery and wire' },
      'copper-ball': { title: 'The copper ball' },
      'robot-and-fan': { title: 'Robot and fan' },
      'switch-and-wire': { title: 'Switch and wire' },
      'lift': { title: 'The lift' },
      'nut-and-spring': { title: 'Nut and spring' },
      'master-workshop': { title: 'The master workshop' },
    },
    scene: { hic: 'HIC!' },
  },
});
